<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="pd-10 bg-white">
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="订单编号">
          <el-input
            v-model="form.num"
            clearable
            placeholder="请输入订单编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单类型">
          <el-select v-model="form.type" clearable placeholder="全部">
            <el-option label="短信套餐充值" value="1"></el-option>
            <el-option label="语音电话套餐充值" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="mgt-30">
      <el-table :data="tableData" border stripe style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="orderNo" label="订单编号"> </el-table-column>
        <el-table-column prop="packageType" label="订单类型">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.packageType == 1
                  ? '短信套餐充值'
                  : scope.row.packageType == 2
                  ? '语音电话套餐充值'
                  : '- -'
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="packageName" label="套餐名称"> </el-table-column>
        <el-table-column prop="packageNum" label="套餐条数"> </el-table-column>
        <el-table-column prop="address" label="每条价格（元）">
          <template slot-scope="scope">
            <span v-text="scope.row.payPrice / scope.row.packageNum"></span>
          </template>
        </el-table-column>
        <el-table-column prop="payPrice" label="支付金额（元）">
        </el-table-column>
        <el-table-column prop="packageRemoveTime" label="到期时间">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.packageRemoveTime
                  ? scope.row.packageRemoveTime
                  : '永久有效'
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="订单状态">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.state == 1
                  ? '待支付'
                  : scope.row.state == 2
                  ? '已支付'
                  : '已到账'
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout=" prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 10, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      form: {},
      tableData: [],
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.communication
        .topList({
          pageNum: this.page,
          pageSize: this.pageSize,
          orderNo: this.form.num,
          packageType: this.form.type,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
    reset() {
      this.form = {};
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
